import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-neelam',
  templateUrl: './neelam.component.html',
  styleUrls: ['./neelam.component.scss']
})
export class NeelamComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getNeelam();
  }

}
